exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-group[data-v-88fb5454] {\n  margin-bottom: 15px;\n}\n.control-label[data-v-88fb5454] {\n  font-weight: bold;\n  margin-bottom: 0;\n}\n.panel[data-v-88fb5454] {\n  margin-bottom: 20px;\n}\n.radio-option-first[data-v-88fb5454] {\n  margin-right: 20px;\n}\n", ""]);

// exports
